import logoutPlaceholder from '../../hooks/logoutPlaceholder.js';

const apiEndPoint = process.env.REACT_APP_FETCH_URL;

export const getReactionSummary = async ({ pageIndex, logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/live/interactions/reaction/${pageIndex}`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            return await response.json();
        }
        catch (error) {
            throw new Error(`Failed parsing page reactions: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not load page reactions: ${response.statusText}`);
};

export const getReactionCsrfToken = async ({ logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/live/interactions/csrf-token`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            return await response.json();
        }
        catch (error) {
            throw new Error(`Failed parsing the page reactions CSRF token: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not load the page reactions CSRF token: ${response.statusText}`);
};

/* `type` is "like" or "dislike"; sending the visitor's current reaction again toggles it off */
export const setPageReaction = async ({ pageIndex, type, csrfToken, logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/live/interactions/reaction/${pageIndex}`, {
        mode: "cors",
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-csrf-token": csrfToken
        },
        body: JSON.stringify({ type })
    });
    if(response.ok) {
        try {
            return await response.json();
        }
        catch (error) {
            throw new Error(`Failed parsing the set page reaction response: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not set page reaction: ${response.statusText}`);
};
